module.exports = __webpack_public_path__ + "static/outsourcing-7a11c899f5307c37523258c7e6662613.jpg";